import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import userPopMixin from "@/views/system/index/mixin/userPopMixin";
export default {
  mixins: [userPopMixin],
  name: "used-list",
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 20
      },
      // 搜索表单
      cityList: [],
      categoryList: [],
      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getCityList();
            _this.getUsedCategoryList();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    getUsedCategoryList: function getUsedCategoryList() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return _this2.$api.getUsedCategoryList();
            case 1:
              res = _context2.v;
              _this2.categoryList = res.data;
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getData: function getData(type) {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (type === "search") {
                _this3.searchForm.pn = 1;
              }
              _this3.tableLoading = true;
              _context3.n = 1;
              return _this3.$api.getUsedList(_this3.searchForm);
            case 1:
              res = _context3.v;
              _this3.tableData = res.data.list;
              _this3.total = res.data.count;
              _this3.tableLoading = false;
              _this3.getUserListByIds(_this3.tableData, "userId");
            case 2:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    getCityList: function getCityList() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this4.$api.getCityList({
                isOpen: 1,
                ps: 100
              });
            case 1:
              res = _context4.v;
              _this4.cityList = res.data.list;
              _this4.tableLoading = false;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    // 开放|关闭
    operation: function operation(row) {
      var _this5 = this;
      this.$confirm("确认操作， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return _this5.$api.operateUsed({
                id: row.id,
                goodsStatus: row.goodsStatus == 2 ? 1 : 2
              });
            case 1:
              _this5.$message.success("操作成功");
              _this5.getData();

              // 操作上报
              _this5.$operationLog.push({
                code: row.goodsStatus == 2 ? 'close' : 'open',
                userId: row.userId,
                operationType: "used",
                detailBatchNo: row.id
              });
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))).catch(function () {});
    },
    // 推荐|取消推荐
    recommend: function recommend(row) {
      var _this6 = this;
      this.$confirm("是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              _context6.n = 1;
              return _this6.$api.recommendUsed({
                id: row.id,
                type: row.isRecommend == 1 ? 0 : 1
              });
            case 1:
              _this6.$message.success("操作成功");
              _this6.getData();

              // 操作上报
              _this6.$operationLog.push({
                code: row.isRecommend == 1 ? 'unrecommend' : 'recommend',
                userId: row.userId,
                operationType: "used",
                detailBatchNo: row.id
              });
            case 2:
              return _context6.a(2);
          }
        }, _callee6);
      }))).catch(function () {});
    },
    updateItem: function updateItem(row) {
      window.open("#/used/update?id=".concat(row.id, "&from=swapsale_list_edit"));
    },
    deleteItem: function deleteItem(row) {
      var _this7 = this;
      this.$confirm("删除， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return _this7.$api.deleteUsed({
                id: row.id
              });
            case 1:
              _this7.$message.success("操作成功");
              _this7.getData();

              // 操作上报
              _this7.$operationLog.push({
                code: 'delete',
                userId: row.userId,
                operationType: "used",
                detailBatchNo: row.id
              });
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      }))).catch(function () {});
    },
    comment: function comment(row) {
      this.$router.push({
        path: "/used/comment",
        query: {
          id: row.id
        }
      });
    }
  }
};